import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import useStores from "../hooks/useStores";

const StoreContext = createContext(null);

export const StoreProvider = ({ children, page, pageSize }) => {
  const storeState = useStores({ page, pageSize });

  return (
    <StoreContext.Provider value={storeState}>
      {children}
    </StoreContext.Provider>
  );
};

StoreProvider.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.number,
  pageSize: PropTypes.number,
};

StoreProvider.defaultProps = {
  page: 1,
  pageSize: 10,
};

export const useStoreContext = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error("useStoreContext must be used within StoreProvider");
  }
  return context;
};

export default StoreContext;
